import {VIEW_ID_MAP, ID_VIEW_MAP} from '~/constants/ProductConstants';

export function isSleeveView({viewId, viewName}) {
  if (viewId) {
    return (
      viewId === VIEW_ID_MAP.leftSleeve || viewId === VIEW_ID_MAP.rightSleeve
    );
  }
  if (viewName) {
    return (
      viewName === ID_VIEW_MAP[VIEW_ID_MAP.leftSleeve] ||
      viewName === ID_VIEW_MAP[VIEW_ID_MAP.rightSleeve]
    );
  }
  return false;
}

export function getProductIdViewIdKey({productId, viewId}) {
  if (!productId || !viewId) return null;
  return `${productId}_${viewId}`;
}

export function getProductIdViewNameKey({productId, viewName}) {
  if (!productId || !viewName) return null;
  return `${productId}_${viewName}`;
}

export function getStyleIdProductColorIdKey({styleId, productColorId}) {
  if (!styleId || !productColorId) return null;
  return `${styleId}_${productColorId}`;
}

export function sortProductByMinQty(productA, productB) {
  if (!productA || !productB) return 0;
  if (productA.min_qty < productB.min_qty) return -1;
  if (productA.min_qty > productB.min_qty) return 1;
  return 0;
}

export function getPromoApparelSuggestionsMix({
  groupSize,
  promoSuggestions,
  apparelSuggestions,
  promoPercentage // 0 .. 100
}) {
  const mixedSuggestions = [];

  for (let i = 0; i < groupSize; i++) {
    const promoIndex = Math.round(groupSize * promoPercentage * 0.01);

    if (i < promoIndex) {
      mixedSuggestions.push(promoSuggestions[i]);
    } else {
      mixedSuggestions.push(apparelSuggestions[i - promoIndex]);
    }
  }

  return mixedSuggestions;
}

export function splitApparelNonApparelSuggestions(suggestions) {
  const promoSuggestions = [];
  const apparelSuggestions = [];

  suggestions?.forEach(suggestion => {
    if (suggestion?.style_type === 'apparel') {
      apparelSuggestions.push(suggestion);
    } else {
      promoSuggestions.push(suggestion);
    }
  });

  return {
    promoSuggestions,
    apparelSuggestions
  };
}

export function getMinQtyFromViolatedProduct({products, desiredQty}) {
  const minQtyViolatedProduct = products.find(
    product => product.color.minimum_quantity > desiredQty
  );
  if (minQtyViolatedProduct) {
    return minQtyViolatedProduct.color.minimum_quantity;
  }
  return null;
}

export function getValidProductColors({style}) {
  if (!style?.colors) return null;

  return style?.colors?.reduce((acc, color) => {
    if (color?.status !== 'active' || color?.stock_issues?.length) {
      return acc;
    }
    acc?.push(color);
    return acc;
  }, []);
}
